export default {
    setTagRules(state, payload) {
        state.tagRule = payload;
    },
    setTags(state, payload) {
        state.tag = payload;
    },
    setWorkspaceTags(state, payload) {
        state.workspaceTag = payload;
    }
}